export default __webpack_public_path__ + "static/media/errorIcon.6ae766eb.svg";